// extracted by mini-css-extract-plugin
export default {"container":"Answer_container__peu74","answer":"Answer_answer__8ondE","answerHeader":"Answer_answerHeader__FB5mw"};